<template>
  <div class="quiz-board">
    <div class="dalao" v-if="luckDalao">
      <div class="dalao-title">
        <ct-icon name="pai"></ct-icon>
        No.{{ luckDalao.ranking }} in cracking battle last week
      </div>
      <div class="dalao-pic">
        <div class="dalao-pic-box">
          <img :src="luckDalao.avatar || defaultPng" alt="">
        </div>
        <p class="dalao-name">{{ luckDalao.user_name }}</p>
        <p class="dalao-sign">{{ luckDalao.user_profile || 'I am a super bad guy' }}</p>
        <img class="dalao-bg-img" src="@/assets/img/comet/quiz/z@2x.png" alt="">
      </div>
      <div class="dalao-mo">
        <div class="dalao-mo-box"
          :class="{
            disabled: moDisable,
            hasMoed
          }"
          @click="moDalao(luckDalao.id)">
          <ct-icon :name="moboxIconname"
            :style="{
              fontSize: hasMoed ? '18px' : '14px',
              marginBottom: hasMoed ? '-1px' : '0',
              marginLeft: hasMoed ? '0' : '2px'}"
              :multi-color="hasMoed"></ct-icon>
          Applause | {{ luckDalao.top }}
        </div>
      </div>
      <div><img width="100%" src="@/assets/img/comet/quiz/Rectangle 15@2x.png" alt=""></div>
    </div>
    <div class="dajia" v-if="dalaoList">
      <div class="dajia-title">
        <h2>
          <ct-icon name="xing"></ct-icon>
          Top 10 learners weekly
        </h2>
        <h5>Updated at {{ updateTime }}</h5>
      </div>
      <div class="dajia-content">
        <div class="dajia-table">
           <table border="0" cellspacing="0" cellpadding="0" width="100%">
            <colgroup>
              <col width="40" />
              <col width="62" />
              <col width="72" />
              <col width="52" />
              <col width="56" />
            </colgroup>
            <thead>
              <tr>
                <th>Ranks</th>
                <th>Nickname</th>
                <th>Q-Answered</th>
                <th>Accuracy</th>
                <th>Applause</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="dalao in dalaoList"
                :key="dalao.user_id">
                <td style="max-width: 40px;">
                  <img v-if="dalao.ranking === 1" src="@/assets/img/comet/quiz/gold.png" alt="">
                  <img v-else-if="dalao.ranking === 2" src="@/assets/img/comet/quiz/silver.png" alt="">
                  <img v-else-if="dalao.ranking === 3" src="@/assets/img/comet/quiz/copper.png" alt="">
                  <span v-else>{{ dalao.ranking }}</span>
                </td>
                <td style="max-width: 62px;">
                  {{ dalao.user_name || 'Anonymous' }}
                </td>
                <td style="max-width: 72px;">
                  {{ dalao.brush_num }}
                </td>
                <td style="max-width: 52px;">
                  {{ dalao.rate }}
                </td>
                <td style="max-width: 56px;">
                  {{ dalao.top }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ct-button @click="showMyRank" :disabled="myRankDisable" type="primary" size="mini">My rank</ct-button>
        <div class="rules-box">
          <ct-button @click="showRules" type="text_secondary_light" size="mini">Ranking rules</ct-button>
        </div>
      </div>
    </div>
    <template
      v-if="top100rank === false">
      <ct-modal
        title=""
        class="rankModal"
        width="480px"
        @closed="rankModal = false"
        v-if="rankModal">
        <div class="rank-modal-body" slot="body">
          <img src="@/assets/img/comet/quiz/heng@2x.png" alt="">
          <h1>Sorry</h1>
          <h3>You were not in the top 100 learner list last week. </h3>
          <h3>Please carry on this week!. </h3>
          <p>Last week you answered {{ myData.brushNum }} questions and the accuracy is {{ myData.correctRate }}</p>
        </div>
        <div slot="footer" class="rank-modal-footer">
          <ct-button @click="rankModal = false" size="small" type="primary">GOT</ct-button>
        </div>
      </ct-modal>
    </template>
    <template v-else-if="top100rank === true">
      <ct-modal
        title=""
        class="rankModal"
        width="480px"
        @closed="rankModal = false"
        v-if="rankModal">
        <div class="rank-modal-body" slot="body">
          <img src="@/assets/img/comet/quiz/Con@2x.png" alt="">
          <h1>Congratulations! </h1>
          <h3>Last week your rank is {{ myData.ranking }}. </h3>
          <h3>You are really good at problem solving!</h3>
          <p>Last week you answered {{ myData.brushNum }} questions and the accuracy is {{ myData.correctRate }}</p>
        </div>
        <div slot="footer" class="rank-modal-footer">
          <ct-button @click="rankModal = false" size="small" type="primary">OK</ct-button>
        </div>
      </ct-modal>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import { vueAppPassportDomin, vueAppDomin } from '@ca/constants/variables.js'
import moment from 'moment'
import defaultPng from '@/assets/img/comet/default.png'

export default {
  name: 'QuizBoard',
  data () {
    return {
      Index: undefined,
      dalaoList: undefined,
      luckDalao: undefined,
      myData: {
        ranking: 0,
        brushNum: 0,
        correctRate: 0
      },
      top100rank: undefined,
      rankModal: false,
      moDisable: false,
      myDataDown: false,
      myRankDisable: false,
      hasMoed: false,
      defaultPng,
      updateTime: 'hh:mm DD/MM'
    }
  },
  methods: {
    showMyRank () {
      if (!this.isAuthenticated) {
        this.$confirm({
          message: 'Sorry, can\'t see your rank before you log in',
          cancelButton: true,
          confirmButtonText: 'Log in',
          handleAction: (confirmed, resolve, reject) => {
            if (confirmed) {
              this.goLogin()
            } else {
              reject()
            }
          }
        })
      } else {
        if (this.myDataDown) {
          this.rankModal = true
          return
        }
        this.myRankDisable = true
        api.getMyWeekRanking().then(res => {
          let data = res.data
          if (data.code === 1) {
            data = data.data
            this.myDataDown = true
            if (data.ranking > 100 || data.ranking < 1) {
              this.top100rank = false
            } else {
              this.top100rank = true
            }
            this.myData = data
            this.myRankDisable = false
            this.rankModal = true
          }
        }).catch(err => {
          this.$toast({
            message: err
          })
          this.myRankDisable = false
        })
      }
    },
    showRules () {
      this.$confirm({
        title: 'Ranking Rules',
        message: `
          1: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          2: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          3: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          4: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          5: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          6: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          7: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
          8: ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules ranking rules .
        `,
        width: '760px',
        confirmButtonText: 'Got it!'
      })
    },
    moDalao (id) {
      if (!this.isAuthenticated) {
        this.goLogin()
      } else {
        this.moDisable = true
        api.updateWorship({
          data: {
            rank_info_id: id
          }
        }).then(res => {
          let data = res.data
          if (data.code === 1) {
            data = data.data
            this.luckDalao.top = data.top
            this.hasMoed = !!data.isTop
          } else {
            this.$toast({
              message: 'oops, something went wrong, please try again later.',
              type: 'error'
            })
          }
          this.moDisable = false
        })
      }
    },
    goLogin () {
      window.location.href = vueAppPassportDomin + 'Login?return_url=' + vueAppDomin + '/courses'
    }
  },
  computed: {
    ...mapGetters(['profile', 'isAuthenticated', 'isAdminRole']),
    moboxIconname () {
      return this.hasMoed ? 'mobai' : 'useful'
    }
  },
  mounted () {
    this.Index = Number(Math.random() * 10).toFixed(0)
    api.getWeekRanking().then(res => {
      let data = res.data
      if (data.code === 1) {
        this.dalaoList = data.data.ranking
        this.luckDalao = data.data.luckUser
        this.hasMoed = !!data.data.isTop
        this.updateTime = moment(data.data.updateTime * 1000).format('HH:mm DD/MM')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .quiz-board {
    box-shadow:0px 2px 12px 0px rgba(35,62,114,0.07);
    border-radius:2px;
    margin-bottom: 40px;
    .dalao {
      .dalao-title {
        display: inline-block;
        height:28px;
        padding: 0 16px;
        background:linear-gradient(180deg,rgba(255,216,121,1) 0%,rgba(250,203,88,1) 100%);
        border-radius:0px 20px 20px 0px;
        line-height: 28px;
        font-size:12px;
        font-weight:500;
        color:rgba(255,255,255,1);
      }
      .dalao-pic {
        margin-top: 12px;
        text-align: center;
        font-size: 0;
        position: relative;
        .dalao-pic-box {
          display: inline-block;
          width: 68px;
          height: 68px;
          border: 4px solid #fff;
          box-shadow:0px 2px 24px 0px rgba(35,62,114,0.12);
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .dalao-name {
          text-align: center;
          font-size:14px;
          font-weight:600;
          color:rgba(26,61,94,1);
          line-height:14px;
          margin: 12px 0 8px;
        }
        .dalao-sign {
          font-size:13px;
          color:rgba(54,85,114,1);
          line-height:20px;
          margin: 0 16px 12px;
          text-align: left;
          word-wrap: break-word;
        }
        .dalao-bg-img {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 68px;
        }
      }
      .dalao-mo {
        text-align: center;
        font-size: 0;
        margin-bottom: 2px;
        .dalao-mo-box {
          display: inline-block;
          padding: 0 16px;
          border-radius:18px;
          border:1px solid rgba(218,224,229,1);
          font-size:14px;
          line-height: 30px;
          font-weight:400;
          color:rgba(54,85,114,1);
          transition: all .5s;
          cursor: pointer;
          &.hasMoed {
            border: 1px solid #37cad7;
          }
          &:hover {
            border: 1px solid #37cad7;
          }
          &.disabled {
            background: #ccc;
          }
        }
      }
    }
    .dajia {
      padding: 24px 16px;
      .dajia-title {
        h2 {
          font-size:16px;
          font-weight:500;
          color:rgba(26,61,94,1);
          line-height:16px;
          margin-bottom: 6px;
        }
        h5 {
          font-size:12px;
          font-weight:400;
          color:rgba(163,177,191,1);
          line-height:12px;
          margin-bottom: 16px;
          padding-left: 21px;
        }
      }
      .dajia-content {
        text-align: center;
        .dajia-table {
          margin-bottom: 8px;
          thead tr {
            background:rgba(247,251,255,1);
            border-radius:2px;
            th {
              font-size:12px;
              font-weight:400;
              color:rgba(54,85,114,1);
              line-height:25px;
              text-align: center;
            }
          }
          td {
            img {
              width: 19px;
              vertical-align: middle;
            }
            font-size:13px;
            font-weight:400;
            color:rgba(26,61,94,1);
            line-height:29px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .rules-box {
          text-align: center;
        }
      }
    }
    .rankModal {
      .rank-modal-body {
        text-align: center;
        img {
          width: 164px;
          vertical-align: middle;
        }
        h1 {
          font-size:20px;
          font-weight:500;
          color:rgba(54,85,114,1);
          line-height:52px;
          text-align: center;
        }
        h3 {
          font-size:14px;
          font-weight:400;
          color:rgba(54,85,114,1);
          line-height:20px;
        }
        p {
          font-size:14px;
          font-weight:400;
          color:rgba(163,177,191,1);
          line-height:20px;
          margin: 24px 0 32px;
        }
      }
    }
    .rank-modal-footer {
      text-align: center;
    }
  }
</style>
